import { StateCreator } from 'zustand';
import { finconnectInitialState, FinconnectState } from './finconnectInitialState';
import { UnifiedTransactionDto } from 'src/types';
import { UnifiedAccount, PowensUser } from 'src/api/finconnect/usersApi';
import { extractEnrichedAccountsFromPowensUser } from 'src/utils/powensUtils';

/**
 * 💡 Ensemble des actions disponibles pour manipuler le store Powens.
 */
export interface FinconnectActions {
  reset: () => void;
  // 🏦 Accounts
  setPowensAccounts: (accounts: UnifiedAccount[]) => void;
  clearAccounts: () => void;
  computeAccountsFromUser: (user: PowensUser | null) => void;
  // 🔹 Sélection du compte
  setSelectedGroupId: (groupId: number | null) => void;
  setSelectedGroupSource: (groupSource: string | null) => void;
  // 🔹 Pagination
  setTransactionsPage: (page: number) => void;
  setTransactionsLimit: (limit: number) => void;

  // 🔹 Filtres temporels
  setTransactionsMinDate: (date: string | null) => void;
  setTransactionsMaxDate: (date: string | null) => void;
  setSelectedTransaction: (selectedTransaction: FinconnectState['selectedTransaction']) => void;
  setIsFilesDialogOpen: (isFilesDialogOpen: boolean) => void;
  setSelectedTransactionForLink: (transaction: UnifiedTransactionDto | null) => void;
  setIsLinkModalOpen: (value: boolean) => void;
}
/*
 * 🧱 Slice Zustand Powens – gère les détails utilisateur, les comptes,
 * la pagination et les filtres de transactions.
 */
export const createFinconnectSlice: StateCreator<FinconnectState & FinconnectActions> = (set) => ({
  ...finconnectInitialState,

  reset: () => set(finconnectInitialState),

  // 🏦 Store enriched accounts
  setPowensAccounts: (accounts) => set({ powensAccounts: accounts }),
  clearAccounts: () => set({ powensAccounts: [] }),

  // 🧠 Compute accounts directly from PowensUser
  computeAccountsFromUser: (user: PowensUser | null) => {
    const enriched = extractEnrichedAccountsFromPowensUser(user ?? ({} as PowensUser));
    set({ powensAccounts: enriched });
  },

  // Account selection
  setSelectedGroupId: (groupId) => set({ selectedGroupId: groupId }),
  setSelectedGroupSource: (groupSource) => set({ selectedGroupSource: groupSource }),
  // Pagination
  setTransactionsPage: (page) => set({ transactionsPage: page }),
  setTransactionsLimit: (limit) => set({ transactionsLimit: limit }),

  // Date filters
  setTransactionsMinDate: (date) => set({ transactionsMinDate: date }),
  setTransactionsMaxDate: (date) => set({ transactionsMaxDate: date }),

  setSelectedTransaction: (selectedTransaction) => set({ selectedTransaction }),
  setIsFilesDialogOpen: (isFilesDialogOpen) => set({ isFilesDialogOpen }),
  setSelectedTransactionForLink: (selectedTransactionForLink) =>
    set({ selectedTransactionForLink }),
  setIsLinkModalOpen: (isLinkModalOpen) => set({ isLinkModalOpen }),
});
